import * as tslib_1 from "tslib";
import axios from 'axios';
/**
 * class PrivateMediaService
 */
var PrivateMediaService = /** @class */ (function () {
    function PrivateMediaService() {
    }
    /**
     * for more information see (https://kb.wixpress.com/pages/viewpage.action?pageId=46730383)
     * @param {{}} params
     * @param token
     * @return {Promise<AxiosResponse<T>>}
     */
    PrivateMediaService.prototype.getFileUploadUrl = function (params, token) {
        if (params === void 0) { params = {}; }
        return axios.get(PrivateMediaService.WIX_FILES + "/site/media/files/upload/url", {
            params: params,
            headers: {
                Authorization: token,
            },
        });
    };
    /**
     * @param {File} image
     * @param authToken - The Private Media Service verifies wixSession2 cookie (JWT token) in order to authenticate client-to-server requests.
     */
    PrivateMediaService.prototype.uploadFile = function (file, authToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, upload_url, upload_token, _b, boundary, formData;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getFileUploadUrl({
                            file_name: file.name,
                            content_type: file.type,
                            file_size: file.size,
                        }, authToken)];
                    case 1:
                        _a = (_c.sent()).data, upload_url = _a.upload_url, upload_token = _a.upload_token;
                        return [4 /*yield*/, this.stringifyFormData(file, upload_token)];
                    case 2:
                        _b = tslib_1.__read.apply(void 0, [_c.sent(), 2]), boundary = _b[0], formData = _b[1];
                        return [2 /*return*/, axios.post(upload_url, formData, {
                                headers: {
                                    'Content-Type': "multipart/form-data; boundary=" + boundary,
                                },
                            })];
                }
            });
        });
    };
    PrivateMediaService.prototype.fileToDataUrl = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                resolve(reader.result);
            });
            reader.addEventListener('error', reject);
            reader.readAsDataURL(file);
        });
    };
    PrivateMediaService.prototype.stringifyFormData = function (file, uploadToken) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dataUrl, boundary, _a, base64File;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fileToDataUrl(file)];
                    case 1:
                        dataUrl = _b.sent();
                        boundary = '--blob';
                        _a = tslib_1.__read(dataUrl.split(','), 2), base64File = _a[1];
                        return [2 /*return*/, [
                                boundary,
                                "\n--" + boundary + "\nContent-Disposition: form-data; name=\"upload_token\"\n\n" + uploadToken + "\n--" + boundary + "\nContent-Disposition: form-data; name=\"file\"; filename=\"" + file.name + "\"\nContent-Type: " + file.type + "\nContent-Transfer-Encoding: base64\n\n" + base64File + "\n--" + boundary + "\nContent-Disposition: form-data; name=\"parent_folder_id\"\n\nmedia-root\n--" + boundary + "--\n",
                            ]];
                }
            });
        });
    };
    PrivateMediaService.WIX_FILES = 'https://files.wix.com';
    return PrivateMediaService;
}());
export { PrivateMediaService };
//# sourceMappingURL=PrivateMediaService.js.map